module.exports = __webpack_public_path__ + "img/广州办公室1.c35262f4.jpg";